import * as React from 'react'
import { type ActivationKey, type LicenseFulfillment } from '../license-lookup.types';

interface LicenseLookupStateObject{
    akey: ActivationKey,
    filteredFulfillments: LicenseFulfillment[]
}

const LicenseLookupContext = React.createContext(null);

const defaultPortalState: LicenseLookupStateObject = {
    akey: null,
    filteredFulfillments: []
}

const LicenseLookupProvider = (props: {children: React.ReactNode}) => {
    const [portalState , setPortalState] = React.useState<LicenseLookupStateObject>(defaultPortalState);
    const val = [portalState, setPortalState];

    return (
        <LicenseLookupContext.Provider value={val}>
            {props.children}
        </LicenseLookupContext.Provider>
    )
}

export {LicenseLookupProvider, LicenseLookupContext, defaultPortalState};